/**
 * Decides if to show the orders tab to the user
 * @param {boolean} isActive - is the user's status active
 * @param {boolean} isPending - is the user's status pending
 * @param {boolean} isRnc - is the user RNC
 * @param {boolean} inShowOrdersNavigatorToRestrictedUsersRollout - is the user in inShowOrdersNavigatorToRestrictedUsersRollout rollout
 * @returns {boolean} - should the user see the orders tab
 */
export const showOrders = ({ isActive, isPending, isRnc, inShowOrdersNavigatorToRestrictedUsersRollout } = {}) => {
    if (isActive) {
        return true;
    }

    // non-activated user that created an order
    if (isPending && !isRnc) {
        return true;
    }
    return inShowOrdersNavigatorToRestrictedUsersRollout;
};
